


























import { EnterpriceBankData } from '@/store/interfaces/company';
import { PAYMENT_TYPES } from '@/const/paymentTypes';
import Vue, { PropType } from 'vue';
import UsdBankData from './UsdBankData.vue';
import UsdtBankData from './UsdtBankData.vue';

export default Vue.extend({
  name: 'ShowBankData',
  components: {
    UsdBankData,
    UsdtBankData,
  },
  props: {
    bankData: {
      type: Object as PropType<EnterpriceBankData>,
      required: true,
    },
    bankDataTitle: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    PAYMENT_TYPES,
  }),
});
